import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { Empty, message, Spin, Typography } from "antd";
import { useEffect } from "react";
import { getActs } from "../api";
import { ActsItem } from "./acts-item";
import styles from "./index.module.scss";

export const ActsList = () => {
  const { t } = useTranslation();

  const [messageApi, contextHolder] = message.useMessage();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["acts"],
    queryFn: () => getActs(),
  });

  useEffect(() => {
    if (isError) {
      messageApi.error(
        (error as any)?.response?.data?.message ||
          "An error occurred while receiving the list of acts",
      );
    }
  }, [isError, error, messageApi]);

  if (isLoading) {
    return (
      <div className={styles.listWrapperLoader}>
        {contextHolder}
        <Spin />
      </div>
    );
  }

  if (!data?.data?.length) {
    return (
      <div className={styles.listWrapper}>
        {contextHolder}
        <Empty
          description={
            <Typography.Text>
              {isError
                ? (error as any)?.response?.data?.message ||
                  "An error occurred while receiving the list of acts"
                : t("acts.list_empty")}
            </Typography.Text>
          }
        />
      </div>
    );
  }

  return (
    <div className={styles.list}>
      {contextHolder}
      {data?.data?.map((item) => (
        <ActsItem act={item} key={item.id} />
      ))}
    </div>
  );
};
